import React from 'react';
import { SingleValueRemove } from './SingleValueRemove.js';
import { MultiValueLabel } from './MultiValueLabel.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/extends';
import 'react-select';
import 'styled-components';
import '@elliemae/ds-icons/CloseXsmall';
import '@elliemae/ds-button';

var SingleValue = function SingleValue(props) {
  // eslint-disable-next-line react/prop-types
  var children = props.children;
  return /*#__PURE__*/React.createElement(MultiValueLabel, {
    clear: /*#__PURE__*/React.createElement(SingleValueRemove, props)
  }, children);
};

export { SingleValue };
//# sourceMappingURL=SingleValue.js.map
